import { AxiosResponse } from 'axios';
import Repository from './Repository';

export type Records = {
  email: string,
  first_name: string,
  last_name: string,
  amount: number,
}

export type CheckFileResponse = {
  data: {
    count: number,
    records: Records[],
    totalAmount: number;
  }
}

type CheckFileError = {
  error: {
    name: string,
    message: string,
    code: number,
  }
}

const mockedCheckFileData: CheckFileResponse = {
  data: {
    count: 7,
    records: [
      {
        email: 'testow43ymail@example.com', first_name: 'Test', last_name: 'test', amount: 50,
      },
      {
        email: 'testowymail@example.com', first_name: 'Testowy', last_name: 'User', amount: 30.53,
      },
      {
        email: 'testowymail@example.com', first_name: 'Testowy5', last_name: 'Test', amount: 234.56,
      },
      {
        email: 'testowymai32@example.com', first_name: 'Testowy2', last_name: 'Test', amount: 23.2,
      },
      {
        email: 'testowymai4@example.com', first_name: 'Testowy4', last_name: 'Test', amount: 10,
      },
      {
        email: 'testowymai5@example.com', first_name: 'Testowy5', last_name: 'Test', amount: 5.3,
      },
      {
        email: 'testowymai6@example.com', first_name: 'Testowy6', last_name: 'Test', amount: 7.5,
      },
    ],
    totalAmount: 361.09,
  },
};

const mockedCheckFileError: CheckFileError = {
  error: {
    code: 0,
    message: '(#2) - Kwota nie może pozostać bez wartości.<br>(#4) - E-mail ,nie może pozostać bez wartości.<br>(#6) - Imię nie może pozostać bez wartości.<br>(#7) - Nazwisko nie może pozostać bez wartości.',
    name: 'Error',
  },
};

const resource = 'virtualcard';
const requestConfig = {
  headers: {
    'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': 'https://localhost:8080/',
  },
};

export default class VirtualCardRepository {
  public static checkFile = (token: string = '', filePath: string = '', productId: string = ''): Promise<AxiosResponse<CheckFileResponse>> => {
    const formData = new FormData();

    formData.append('token', token);
    formData.append('vc_file', filePath);
    formData.append('productId', productId);

    return Repository.post(`${resource}/upload-file`, formData, requestConfig);
  }

  public static checkFileMock = (token: string, filePath: string): Promise<CheckFileResponse> => new Promise((resolve, reject) => {
    if (!token && !filePath) {
      reject(mockedCheckFileError);
    }

    setTimeout(() => {
      resolve(mockedCheckFileData);
    }, 100);
  })
}
